import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { headerDataStyles } from './HeaderData.style';
var HeaderData = function (props) {
    var classes = headerDataStyles().classes;
    var heading = props.heading, subheading = props.subheading;
    return (_jsxs(Box, { className: classes.headerData, "data-testid": 'print-header-data', children: [_jsx(Typography, { component: "div", component: 'h1', className: classes.heading, children: heading }), _jsx(Typography, { component: "div", component: 'h2', className: classes.subheading, children: subheading })] }));
};
export default HeaderData;
